module.exports = __webpack_public_path__ + "assets/images/logo.jpg?hash=fd031a7553e383f9fd27";